import React from "react";
import { Grid } from "@material-ui/core";

const GridSpacing = ({ size }: { size: number }): React.ReactElement => {
    return <Grid item xs={12} style={{ height: `${size}px` }} />;
};

export default GridSpacing;
